import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, withModifiers as _withModifiers, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "width-wrap"
}
const _hoisted_2 = { class: "section-header" }
const _hoisted_3 = { class: "heading heading--md" }
const _hoisted_4 = {
  key: 0,
  class: "form-messages"
}
const _hoisted_5 = {
  key: 0,
  class: "flashmessage flash-success"
}
const _hoisted_6 = {
  key: 1,
  class: "flashmessage flash-danger"
}
const _hoisted_7 = {
  key: 1,
  class: "form-body"
}
const _hoisted_8 = { class: "form-group" }
const _hoisted_9 = { for: "frm-estateAgentReviewForm_email" }
const _hoisted_10 = { class: "input-with-button" }
const _hoisted_11 = ["placeholder"]
const _hoisted_12 = { class: "button button--primary" }
const _hoisted_13 = {
  key: 0,
  class: "form-error"
}
const _hoisted_14 = {
  key: 1,
  class: "form-error"
}
const _hoisted_15 = { class: "section-header" }
const _hoisted_16 = { class: "heading heading--md" }
const _hoisted_17 = { class: "review-list" }
const _hoisted_18 = { class: "review" }
const _hoisted_19 = { class: "review__rating" }
const _hoisted_20 = { class: "rating rating--stars" }
const _hoisted_21 = { class: "review__text" }
const _hoisted_22 = { class: "review__actions" }
const _hoisted_23 = { class: "section-header" }
const _hoisted_24 = { class: "heading heading--md" }
const _hoisted_25 = { class: "review-request-list" }
const _hoisted_26 = { class: "review-request" }
const _hoisted_27 = { class: "review-request__email" }
const _hoisted_28 = { class: "review-request__date" }
const _hoisted_29 = { class: "review_request__actions" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EstateAgentReviewStars = _resolveComponent("EstateAgentReviewStars")!

  return (!_ctx.isInitializing)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (!_ctx.review)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('EstateAgentReviewRequestForm.header')), 1)
              ]),
              _createElementVNode("form", {
                id: "review-request-form",
                class: "form",
                onSubmit: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.send && _ctx.send(...args)), ["prevent"])),
                autocomplete: "off"
              }, [
                (_ctx.showFormMessages)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                      (_ctx.isSuccess)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.$t('EstateAgentReviewRequestForm.success', { email: _ctx.form.email })), 1))
                        : _createCommentVNode("", true),
                      (_ctx.isError)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_ctx.$t('forms.required-fields')), 1))
                        : _createCommentVNode("", true),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors, (error, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: index,
                          class: "flashmessage flash-danger"
                        }, _toDisplayString(error), 1))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true),
                (!_ctx.isSuccess)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                      _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("div", {
                          class: _normalizeClass(["form-field", { 'is-danger': _ctx.v$.form.email.$error }])
                        }, [
                          _createElementVNode("label", _hoisted_9, _toDisplayString(_ctx.$t('EstateAgentReviewRequestForm.email')) + ":", 1),
                          _createElementVNode("div", _hoisted_10, [
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.v$.form.email.$model) = $event)),
                              type: "text",
                              id: "frm-estateAgentReviewForm_email",
                              placeholder: _ctx.$t('EstateAgentReviewRequestForm.email-placeholder'),
                              name: "email",
                              class: "form-control is-required"
                            }, null, 8, _hoisted_11), [
                              [
                                _vModelText,
                                _ctx.v$.form.email.$model,
                                void 0,
                                { trim: true }
                              ]
                            ]),
                            _createElementVNode("button", _hoisted_12, _toDisplayString(_ctx.$t('forms.send')), 1)
                          ]),
                          (_ctx.v$.form.email.$dirty && _ctx.v$.form.email.$invalid)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                (_ctx.v$.form.email.required.$invalid)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(_ctx.$t('forms.required')), 1))
                                  : _createCommentVNode("", true),
                                (_ctx.v$.form.email.email.$invalid)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(_ctx.$t('forms.email')), 1))
                                  : _createCommentVNode("", true)
                              ], 64))
                            : _createCommentVNode("", true)
                        ], 2)
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ], 32)
            ], 64))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              (_ctx.review.hasReview)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.$t('EstateAgentReviewRequestForm.review')), 1)
                    ]),
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("div", _hoisted_18, [
                        _createElementVNode("div", _hoisted_19, [
                          _createElementVNode("div", _hoisted_20, [
                            _createVNode(_component_EstateAgentReviewStars, {
                              rating: _ctx.review.rating
                            }, null, 8, ["rating"])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.review.review), 1),
                        _createElementVNode("div", _hoisted_22, [
                          (!_ctx.review.isPublished)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                class: "button button--primary",
                                type: "button",
                                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.publishReview()))
                              }, _toDisplayString(_ctx.$t('EstateAgentReviewRequestForm.publish')), 1))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ])
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createElementVNode("div", _hoisted_23, [
                      _createElementVNode("div", _hoisted_24, _toDisplayString(_ctx.$t('EstateAgentReviewRequestForm.review-request')), 1)
                    ]),
                    _createElementVNode("div", _hoisted_25, [
                      _createElementVNode("div", _hoisted_26, [
                        _createElementVNode("div", _hoisted_27, [
                          _createElementVNode("strong", null, _toDisplayString(_ctx.$t('EstateAgentReviewRequestForm.email')) + ":", 1),
                          _createElementVNode("span", null, _toDisplayString(_ctx.review.email), 1)
                        ]),
                        _createElementVNode("div", _hoisted_28, [
                          _createElementVNode("strong", null, _toDisplayString(_ctx.$t('EstateAgentReviewRequestForm.date')) + ":", 1),
                          _createElementVNode("span", null, _toDisplayString(_ctx.$filters.date(_ctx.review.sentDate, 'dd. MM. yyyy HH:mm')), 1)
                        ]),
                        _createElementVNode("div", _hoisted_29, [
                          _createElementVNode("button", {
                            class: "button button--danger",
                            type: "button",
                            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.deleteReview()))
                          }, _toDisplayString(_ctx.$t('EstateAgentReviewRequestForm.cancel-request')), 1)
                        ])
                      ])
                    ])
                  ], 64))
            ], 64))
      ]))
    : _createCommentVNode("", true)
}